import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../api/api';
import { Allergen } from '../../types';

interface AllergenState {
  items: Allergen[];
  loading: boolean;
}

export const fetchAllergens = createAsyncThunk('allergen/fetchAll', async () => {
  const res = await api.get<Allergen[]>('/allergens');
  return res.data;
});

export const createAllergen = createAsyncThunk('allergen/create', async (data: any) => {
  const res = await api.post<Allergen>('/allergens', data);
  return res.data;
});

export const updateAllergen = createAsyncThunk(
  'allergen/update',
  async ({ id, data }: { id: number; data: any }) => {
    const res = await api.put<Allergen>(`/allergens/${id}`, data);
    return res.data;
  }
);

export const deleteAllergen = createAsyncThunk('allergen/delete', async (id: number) => {
  await api.delete(`/allergens/${id}`);
  return id;
});

const allergenSlice = createSlice({
  name: 'allergen',
  initialState: { items: [], loading: false } as AllergenState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllergens.pending, (state) => { state.loading = true; })
      .addCase(fetchAllergens.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchAllergens.rejected, (state) => { state.loading = false; })
      .addCase(createAllergen.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateAllergen.fulfilled, (state, action) => {
        const idx = state.items.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      })
      .addCase(deleteAllergen.fulfilled, (state, action) => {
        state.items = state.items.filter((i) => i.id !== action.payload);
      });
  },
});

export default allergenSlice.reducer;
